import { ETariffAbbr, type Widgets } from '@common/enums';
import { currentTariffSetIndex, tariffElementsMap } from '@web/core/constants/tariff.const';

export const getCurrentTariffSet = (currentTariffAbbr: ETariffAbbr) => {
    let tariffSet = tariffElementsMap[currentTariffSetIndex];
    const tariffSets = Object.values(tariffElementsMap);

    if (currentTariffAbbr !== ETariffAbbr.FREE) {
        tariffSets.forEach((set) => {
            if (set[currentTariffAbbr]) {
                tariffSet = set;
            }
        });
    }

    return tariffSet;
};

export const checkIsElementAvailable = (widgetName: Widgets, currentTariffAbbr: ETariffAbbr) => {
    if (!widgetName || !currentTariffAbbr) return { hasAccess: false, nextTariff: null };

    const tariffSet = getCurrentTariffSet(currentTariffAbbr);
    // An abbr outside the known tariff sets (an education-only account, a legacy plan) falls back to the free scope.
    const availableWidgets = tariffSet[currentTariffAbbr] ?? tariffSet[ETariffAbbr.FREE] ?? [];
    const hasAccess = availableWidgets.includes(widgetName);
    const nextTariff = hasAccess ? '' : Object.keys(tariffSet).find((tariff) => tariffSet[tariff].includes(widgetName));

    return { hasAccess, nextTariff, tariffSet };
};
